import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=1c53b2e0&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=ts"
export * from "./DataTable.vue?vue&type=script&lang=ts"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=1c53b2e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53b2e0",
  null
  
)

export default component.exports